import { formAddCsrfProtection } from "./utils";

class MultiRating {
	constructor(slider) {
		if (slider) {
			this.parent = document.querySelector(slider.dataset.parent_id);
			this.label = document.querySelector(slider.dataset.label_id);
			this.can_delete = slider.dataset.can_delete;
			slider.dataset.initialized = 1;

			slider.addEventListener("input", () => {
				this.updateVoteLabel(slider);
			});

			slider.addEventListener("change", (event) => {
				const rating_vote = slider.value;
				const target = event.target;

				// login window
				if (
					!!document.querySelector("#login_registration_container") &&
					!!document.querySelector("#user_nav #_user_panel_container") === false
				) {
					const ratingLoginWindow = () => {
						globalLoginWindowHandler.openLoginWindow();
						globalLoginWindowHandler.delegate = target;

						// Delegate function
						target.authenticationSucceded = () => {
							globalLoginWindowHandler.removeEventHandlers();
							globalLoginWindowHandler.getUserData(() => {
								this.voteCallback(rating_vote, target);
								this.updateVoteLabel(target, rating_vote);
								if (target.value !== rating_vote) {
									target.value = rating_vote;
								}
							});
						};

						// Delegate function
						target.authenticationFailedWithError = (error) => {
							this.resetVote(target);
						};
					};
					ratingLoginWindow();
				} else {
					this.voteCallback(rating_vote, target);
				}
			});
		}
	}

	resetVote(slider) {
		this.parent.value = "0.0";
		this.label.textContent = "-";
		slider.value = 0;
	}

	updateVoteLabel(slider, voteParam) {
		let currentVote =
			typeof voteParam === "undefined" ? slider.value : voteParam;
		if (Number.isInteger(currentVote)) {
			currentVote = currentVote.toPrecision(2);
		}
		if (currentVote === 0) {
			this.resetVote(slider);
		} else {
			this.label.textContent = currentVote;
		}
	}

	voteCallback(rating_vote, slider) {
		const vote_form = slider.closest("form");
		if (this.can_delete) {
			if (rating_vote < 1) {
				// valorizzo la input a 0 => eliminazione voto utente(se presente)
				this.resetVote(slider);
			} else {
				this.parent.value = rating_vote;
			}
		} else {
			if (rating_vote > 0) {
				this.parent.value = rating_vote;
			}
		}
		slider.setAttribute("disabled", true);

		formAddCsrfProtection(vote_form).then((data) => {
			const formData = new FormData(vote_form);
			fetch(vote_form.getAttribute("action"), {
				headers: {
					"X-Requested-With": "XMLHttpRequest",
				},
				method: "POST",
				body: formData,
			})
				.then((response) => {
					if (response.ok) {
						return response.json();
					}
					console.warn(" --- Error: ", response.statusText);
					this.resetVote(slider);
				})
				.then((data) => {
					slider.removeAttribute("disabled");
				})
				.catch((error) => {
					console.warn(" --- Error: ", error);
					this.resetVote(slider);
				});
		});
	}
}

export const initRating = () => {
	for (const slider of document.querySelectorAll("._rating-slider")) {
		if (slider.dataset.initialized === "0") {
			const rating = new MultiRating(slider);
		}
	}
};
